// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getPipProduct} from '../../shared/repositories';
import {readCustomer} from './customer';

export const readPipProduct = id =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getPipProduct(id);

            if (data.customerSummary.id) {

                readCustomer(data.customerSummary.id)(dispatch);

            }

            dispatch({
                data,
                type: actions.READ_PIP_PRODUCT_SUCCESS
            });

            dispatch({
                isFormVisible: true,
                type: actions.UPDATE_PIP_CODE_FORM_VISIBILITY
            });

        } catch (error) {

            dispatch({
                isFormVisible: false,
                type: actions.UPDATE_PIP_CODE_FORM_VISIBILITY
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/pip-product.js